import React, { forwardRef } from 'react';
import PropTypes        from 'prop-types';

import AutomationsBG    from '../../../../../assets/images/automations.png';
import IconCheck        from '../../../../../assets/images/icon_check.png';

import styles           from './OpportunitiesBlock.styl';

function OpportunitiesBlock(props, ref) {
    // const {  } = props;

    // const {} = useMessage();

    return  (
        <section
            className={styles.OpportunitiesBlock}
            ref = {ref}
        >
            <div className={styles.leftBlock}>
                <div className={styles.blockName}>
                    <span className={styles.dot} />
                    Opportunities
                </div>
                <h2 className={styles.blockTitle}>
                    Your opportunities with Roimax
                </h2>
                <div className={styles.list}>
                    <div className={styles.listItem}>
                        <img
                            src       = {IconCheck}
                            className = {styles.checkIcon}
                        />
                        <div className={styles.itemText}>
                            Automate multiple Ad Networks at the same time.
                        </div>
                    </div>
                    <div className={styles.listItem}>
                        <img
                            src       = {IconCheck}
                            className = {styles.checkIcon}
                        />
                        <div className={styles.itemText}>
                            Customize the level of risk.
                        </div>
                    </div>
                    <div className={styles.listItem}>
                        <img
                            src       = {IconCheck}
                            className = {styles.checkIcon}
                        />
                        <div className={styles.itemText}>
                            Create your advertising strategy in a variety of styles with automatic daily, weekly, and long-term optimizations.
                        </div>
                    </div>
                    <div className={styles.listItem}>
                        <img
                            src       = {IconCheck}
                            className = {styles.checkIcon}
                        />
                        <div className={styles.itemText}>
                            Limit the number of changes.
                        </div>
                    </div>
                    <div className={styles.listItem}>
                        <img
                            src       = {IconCheck}
                            className = {styles.checkIcon}
                        />
                        <div className={styles.itemText}>
                            {'Save your time and avoid the monitoring charts day and night.'}
                        </div>
                    </div>
                    <div className={styles.listItem}>
                        <img
                            src       = {IconCheck}
                            className = {styles.checkIcon}
                        />
                        <div className={styles.itemText}>
                            Prevent errors caused by human factors to increase your profitability.
                        </div>
                    </div>
                    <div className={styles.listItem}>
                        <img
                            src       = {IconCheck}
                            className = {styles.checkIcon}
                        />
                        <div className={styles.itemText}>
                            Run automation using API of Ad Networks (like Meta, Applovin, Unity Ads, Google Ads, Tik Tok, etc.).
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.rightBlock}>
                <img
                    src       = {AutomationsBG}
                    className = {styles.automationsImage}
                />
            </div>
        </section>
    );
}

OpportunitiesBlock.propTypes = {
    className : PropTypes.string,
    message   : PropTypes.string
};

OpportunitiesBlock.defaultProps = {
    className : '',
    message   : ''
};

export default forwardRef(OpportunitiesBlock);
